import { imageService } from "../services/ImageService";

/**
 * Complete list of major arcana cards (0-21)
 */
export const MAJOR_ARCANA_NAMES: string[] = [
  "The Fool",
  "The Magician",
  "The High Priestess",
  "The Empress",
  "The Emperor",
  "The Hierophant",
  "The Lovers",
  "The Chariot",
  "Strength",
  "The Hermit",
  "Wheel of Fortune",
  "Justice",
  "The Hanged Man",
  "Death",
  "Temperance",
  "The Devil",
  "The Tower",
  "The Star",
  "The Moon",
  "The Sun",
  "Judgement",
  "The World",
] as const;

/**
 * Complete list of minor arcana cards
 * Following the naming convention: "Number/Court of Suit"
 */
export const MINOR_ARCANA_NAMES: string[] = [
  // Cups
  "Ace of Cups",
  "Two of Cups",
  "Three of Cups",
  "Four of Cups",
  "Five of Cups",
  "Six of Cups",
  "Seven of Cups",
  "Eight of Cups",
  "Nine of Cups",
  "Ten of Cups",
  "Page of Cups",
  "Knight of Cups",
  "Queen of Cups",
  "King of Cups",

  // Pentacles
  "Ace of Pentacles",
  "Two of Pentacles",
  "Three of Pentacles",
  "Four of Pentacles",
  "Five of Pentacles",
  "Six of Pentacles",
  "Seven of Pentacles",
  "Eight of Pentacles",
  "Nine of Pentacles",
  "Ten of Pentacles",
  "Page of Pentacles",
  "Knight of Pentacles",
  "Queen of Pentacles",
  "King of Pentacles",

  // Swords
  "Ace of Swords",
  "Two of Swords",
  "Three of Swords",
  "Four of Swords",
  "Five of Swords",
  "Six of Swords",
  "Seven of Swords",
  "Eight of Swords",
  "Nine of Swords",
  "Ten of Swords",
  "Page of Swords",
  "Knight of Swords",
  "Queen of Swords",
  "King of Swords",

  // Wands
  "Ace of Wands",
  "Two of Wands",
  "Three of Wands",
  "Four of Wands",
  "Five of Wands",
  "Six of Wands",
  "Seven of Wands",
  "Eight of Wands",
  "Nine of Wands",
  "Ten of Wands",
  "Page of Wands",
  "Knight of Wands",
  "Queen of Wands",
  "King of Wands",
] as const;

/**
 * Complete list of all tarot cards (Major + Minor Arcana)
 */
export const TAROT_CARD_NAMES: string[] = [
  ...MAJOR_ARCANA_NAMES,
  ...MINOR_ARCANA_NAMES,
] as const;

export type CardName = (typeof TAROT_CARD_NAMES)[number];

/**
 * Get a random tarot card from the available cards
 * @returns Random tarot card name
 */
export const getRandomTarotCard = (): (typeof TAROT_CARD_NAMES)[number] => {
  const randomIndex = Math.floor(Math.random() * TAROT_CARD_NAMES.length);
  return TAROT_CARD_NAMES[randomIndex];
};

/**
 * Get the image path for a tarot card
 * @param cardName - Name of the tarot card
 * @returns Path to the card image
 */
export const getCardImagePath = (cardName: string): string => {
  return imageService.getCardImagePath(cardName);
};

/**
 * Preload a card image for better UX
 * @param cardName - Name of the card to preload
 * @returns Promise that resolves when image is loaded
 */
export const preloadCardImage = async (cardName: string): Promise<string> => {
  return imageService.preloadCard(cardName);
};
